var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgExternal = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.023 0C10.386 0 9.87.52 9.87 1.16c0 .641.517 1.161 1.154 1.161h5.038l-9.284 9.338a1.165 1.165 0 0 0 0 1.641 1.15 1.15 0 0 0 1.632 0l9.283-9.338V9.03c0 .641.517 1.16 1.154 1.16.637 0 1.154-.519 1.154-1.16V1.16A1.16 1.16 0 0 0 18.846 0h-7.823Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.951 2.985A2.951 2.951 0 0 0 0 5.936v11.095a2.951 2.951 0 0 0 2.951 2.951h11.01a2.951 2.951 0 0 0 2.95-2.95v-3.607a1.157 1.157 0 1 0-2.313 0v3.606a.637.637 0 0 1-.637.637H2.95a.637.637 0 0 1-.637-.637V5.936c0-.351.285-.637.637-.637H7.5a1.157 1.157 0 0 0 0-2.314H2.95Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgExternal);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/external.4ffdd6b542e7c5873060b7d25eb7533c.svg";